// dependencies
import React, { useState, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { StyleSheet } from "aphrodite";

// components
import Text from "@cloudspire/legacy-resources/src/components/Text2";
import Link from "@cloudspire/legacy-resources/src/components/Link2";
import { IconPhoneO } from "@cloudspire/legacy-svg-icon-library";

// libraries
import { noop } from "@cloudspire/legacy-shared/src/libraries";

const styles = StyleSheet.create({
  spoilerPhone: {
    cursor: "pointer",
  },
});

type PropsType = {
  phone: string;
  onPress?;
};

const SpoilerPhone: React.FunctionComponent<PropsType> = (props) => {
  const { phone, onPress = noop, ...otherProps } = props;

  const [spoiled, setSpoiled] = useState(false);

  const handleClick = useCallback(
    (event) => {
      event.persist();

      setSpoiled(true);

      onPress(event);
    },
    [onPress]
  );

  if (spoiled) {
    return (
      <Link
        {...otherProps}
        aStyle={styles.spoilerPhone}
        to={`tel:${phone}`}
        onClick={handleClick}
      >
        <FormattedMessage defaultMessage="Téléphone">
          {(chunks) => (
            <>
              <IconPhoneO />
              &nbsp;{!spoiled ? chunks : phone}
            </>
          )}
        </FormattedMessage>
      </Link>
    );
  } else {
    return (
      <Text aStyle={styles.spoilerPhone} onClick={handleClick}>
        <FormattedMessage defaultMessage="Téléphone">
          {(chunks) => (
            <>
              <IconPhoneO />
              &nbsp;{!spoiled ? chunks : phone}
            </>
          )}
        </FormattedMessage>
      </Text>
    );
  }
};

export default SpoilerPhone;
